var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.89543 0 0 0.895431 0 2V13.1716C0 14.9534 2.15428 15.8457 3.41421 14.5858L8.41421 9.58579C8.78929 9.21071 9 8.70201 9 8.17157V2C9 0.89543 8.10457 0 7 0H2ZM17 0C15.8954 0 15 0.895431 15 2V13.1716C15 14.9534 17.1543 15.8457 18.4142 14.5858L23.4142 9.58579C23.7893 9.21071 24 8.70201 24 8.17157V2C24 0.89543 23.1046 0 22 0H17Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote1);
export default __webpack_public_path__ + "static/media/quote-1.60b75ec95f9c67b372fd9f9b376bace8.svg";
export { ForwardRef as ReactComponent };